import React, { forwardRef } from "react";
import useReveal from "@/hooks/useReveal";

const Reveal = forwardRef(function Reveal(
  { as: Tag = "div", className = "", children, delay = 0, style, ...rest },
  forwardedRef
) {
  const revealRef = useReveal();

  const setRefs = (node) => {
    revealRef.current = node;
    if (typeof forwardedRef === "function") forwardedRef(node);
    else if (forwardedRef) forwardedRef.current = node;
  };

  return (
    <Tag
      ref={setRefs}
      className={`reveal ${className}`.trim()}
      style={{
        ...style,
        transitionDelay: delay ? `${delay}ms` : style?.transitionDelay,
      }}
      {...rest}
    >
      {children}
    </Tag>
  );
});

export default Reveal;
